// extracted by mini-css-extract-plugin
export default {"collapsePanel":"SummaryCollapse_collapsePanel__sn7SD","panelHeader":"SummaryCollapse_panelHeader__ne0SO"};